import { render, staticRenderFns } from "./CDatePicker.vue?vue&type=template&id=96841c2c&scoped=true"
import script from "./CDatePicker.vue?vue&type=script&lang=js"
export * from "./CDatePicker.vue?vue&type=script&lang=js"
import style0 from "./CDatePicker.vue?vue&type=style&index=0&id=96841c2c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96841c2c",
  null
  
)

export default component.exports